// extracted by mini-css-extract-plugin
export default {"ingredient":"constructor-mains_ingredient__pys7G"};